import { AnyAction } from 'redux';

export const isPendingAction =
  (prefixName: string) =>
  (action: AnyAction): boolean =>
    action.type.startsWith(prefixName) && action.type.endsWith('pending');

export const isRejectedAction =
  (prefixName: string) =>
  (action: AnyAction): boolean =>
    action.type.startsWith(prefixName) && action.type.endsWith('rejected');

export const isFulfilledAction =
  (prefixName: string) =>
  (action: AnyAction): boolean =>
    action.type.startsWith(prefixName) && action.type.endsWith('fulfilled');
